export interface ReleaseNote {
  date: string;
  title: string;
  changes: readonly string[];
}

export const releaseNotes: readonly ReleaseNote[] = [
  {
    date: "2026-09-22",
    title: "Core billing workflows",
    changes: [
      "Manage clients and their contacts.",
      "Create and edit invoice and estimate drafts.",
      "Issue invoices and download their PDFs.",
      "Record manual invoice payments and review payment history.",
      "Archive and restore invoices without losing their history.",
      "Use bulk actions to archive selected invoices or record a separate payment amount for each eligible invoice.",
      "Review year-end invoice and payment reports.",
    ],
  },
];

export const upcoming: readonly string[] = [
  "Advanced invoice filters",
  "All-time CSV export",
  "SignalBill business-named export files",
];
